import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizOptions from "../shared/QuizOptions";
import BackgroundVideo from "../shared/BackgroundVideo";
import PromotionContent from "../shared/PromotionContent";
import { VIDEO_URLS } from "../../utils/videoConfig";

const Step11 = ({ onContinue }) => {
  return (
    <QuizContent>
      <QuizOptions>
        <BackgroundVideo className="bgVideoStep11" src={VIDEO_URLS.video4} />
        <PromotionContent onContinue={onContinue}>
          <h2>
            <strong>
              You deserve to be accepted and understood for who you are
            </strong>
          </h2>
        </PromotionContent>
      </QuizOptions>
    </QuizContent>
  );
};

export default Step11;
